module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/2845474ed42a14c929722d41b41e8560.jpg";